import Vue from 'vue'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)


// WEBPACK FOOTER //
// ./resources/js/plugins/form-wizard.js